(() => {
  if (window.ojBookingAnalyticsReady) return;
  window.ojBookingAnalyticsReady = true;
  const appOrigin = 'https://pixel-perfect-canvas-5223.lovable.app';
  const storageKey = 'oj-booking-measured-v1';
  const seen = new Set();
  const pending = new Set();

  const allowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch {
      return false;
    }
  };

  const deliver = (data, attempt = 0) => {
    if (!allowed()) {
      pending.delete(data.bookingKey);
      return;
    }
    if (typeof window.gtag !== 'function') {
      if (attempt < 25) window.setTimeout(() => deliver(data, attempt + 1), 200);
      else pending.delete(data.bookingKey);
      return;
    }
    try {
      JSON.parse(window.sessionStorage.getItem(storageKey) || '[]').forEach((key) => seen.add(key));
    } catch {}
    if (seen.has(data.bookingKey)) {
      pending.delete(data.bookingKey);
      return;
    }
    const payload = {
      boutique: data.boutique,
      appointment_type: data.appointmentType,
      booking_language: data.locale,
    };
    try {
      window.gtag('event', 'book_appointment', { ...payload, send_to: 'G-RP3QNBK2B3' });
      seen.add(data.bookingKey);
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify([...seen].slice(-30)));
      } catch {}
      try {
        const published = window.Shopify?.analytics?.publish('oj:appointment_completed', payload);
        if (published && typeof published.catch === 'function') published.catch(() => {});
      } catch {}
    } catch {}
    pending.delete(data.bookingKey);
  };

  window.addEventListener('message', (event) => {
    if (event.origin !== appOrigin) return;
    const frames = document.querySelectorAll('#oj-booking-popup iframe, #oj-booking-frame iframe');
    if (![...frames].some((frame) => frame.contentWindow === event.source)) return;
    const data = event.data;
    if (data?.type !== 'oj-booking-completed' || data.version !== 1) return;
    if (!/^oj[a-f0-9]{40}$/.test(data.bookingKey || '')) return;
    if (!['antwerp', 'brussels'].includes(data.boutique)) return;
    if (!['engagement', 'custom', 'specific-piece', 'care', 'discover'].includes(data.appointmentType)) return;
    if (!['en', 'nl', 'fr'].includes(data.locale)) return;
    if (pending.has(data.bookingKey) || seen.has(data.bookingKey)) return;
    pending.add(data.bookingKey);
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (error) pending.delete(data.bookingKey);
        else deliver(data);
      });
      return;
    }
    deliver(data);
  });
})();
